/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyGithubIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-github" */ './utils').then((m) => m.GithubIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/github/icon' },
);

const LazyGithubSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-github-search-result" */ './utils').then(
			(m) => m.GithubSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const GithubIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGithubIconComponent />
	</Suspense>
);

export const GithubSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGithubSearchResultIconComponent />
	</Suspense>
);
